import { Injectable } from '@angular/core'
import { ApiClient, ApiClientFactory } from '@ftr/api-shared'
import { ConfigureDepartmentsBody } from '@ftr/contracts/api/court-system/ConfigureDepartmentsBody'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, createAndAssign } from '@ftr/foundation'
import { classToPlain } from '@ftr/serialization'

export enum EnableDisable {
  enable = 'enable',
  disable = 'disable',
}

@Injectable()
export class EnableDisableDepartmentsFeatureService {
  private readonly apiClient: ApiClient

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClient = apiClientFactory.build('/court-system')
  }

  update(courtSystemId: Uuid, isEnabled: boolean): ApiResult {
    return this.apiClient.post({
      path: `/${courtSystemId}/configureDepartments`,
      body: classToPlain(
        createAndAssign(ConfigureDepartmentsBody, {
          isEnabled,
        }),
      ),
    })
  }

  actionTerm(isFeatureEnabled: boolean): EnableDisable {
    return isFeatureEnabled ? EnableDisable.enable : EnableDisable.disable
  }
}
